import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { ContactCornSchema } from '@eigtech/contacts-types';
import { DocumentCornSchema } from '@eigtech/documents-types';
import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { DraftDocumentRecordSchema } from '../base/draftDocument.js';
import { GuidedDocumentTypeSchema } from '../base/guidedDocument.js';
export const GenerateGuidedDocumentPathSchema = z.object({
    carrierContactCorn: ContactCornSchema,
    entityId: ClaimV2CornSchema,
});
export const GenerateGuidedDocumentRequestBodySchema = z.object({
    type: GuidedDocumentTypeSchema,
    /** User input for the guided document. */
    guidedStatement: z.string().optional().describe('User input for the guided document.'),
    /** Supporting documents to inform guided document generation. */
    documentCorns: DocumentCornSchema.array()
        .optional()
        .describe('Supporting documents to inform guided document generation.'),
});
export const GenerateGuidedDocumentHeadersSchema = ApiLambdalerAuthHeaderSchema;
export const GenerateGuidedDocumentRequestSchema = GenerateGuidedDocumentPathSchema.merge(GenerateGuidedDocumentHeadersSchema.merge(GenerateGuidedDocumentRequestBodySchema));
export const GenerateGuidedDocumentResponseSchema = DraftDocumentRecordSchema;
export const GenerateGuidedDocumentApiSchema = {
    body: GenerateGuidedDocumentRequestBodySchema,
    params: GenerateGuidedDocumentPathSchema,
    headers: GenerateGuidedDocumentHeadersSchema,
    response: GenerateGuidedDocumentResponseSchema,
};
